import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useValidator } from '@arema/components/Hooks';
import { Button, Icon, Input, Message } from 'react-frontier';
import { Link, useLocation } from 'react-router-dom';
import { SetLoading } from '@arema/components/Classes';
import { useAuth } from '../AuthHooks';
import API, { CDN_URL } from '../AuthAPI';

var AccountCreate = ()=>{
	var { t } = useTranslation();
	var { search } = useLocation();
	var { getCaptcha } = useAuth();
	var [created, setCreated] = useState<boolean>(false);
	var form = useValidator({
		first_name: '',
		last_name: '',
		email: '',
		password: '',
		repeat_password: '',
	}, {
		first_name: [{ rule: 'minLength', params: [3], prompt: t('create.prompts.first_name', { min: 3 }) }],
		last_name: [{ rule: 'minLength', params: [3], prompt: t('create.prompts.last_name', { min: 3 }) }],
		email: [{ rule: 'email', prompt: t('create.prompts.email') }],
		password: [{ rule: 'length', params: [8, 128], prompt: t('create.prompts.password', { amount: 8 }) }],
		repeat_password: [{ rule: 'matches', params: ['password'], prompt: t('create.prompts.repeat') }],
	});

	var createAccount = async (setLoading: SetLoading)=>{
		var { valid } = form.validate();
		if(!valid) return;

		setLoading(true);
		try{
			var captcha = await getCaptcha();
			if(!captcha){
				setLoading(false);
				return form.setPrompts([t('common.captcha_error')]);
			}
		}catch(e){
			form.setPrompts([t('common.captcha_error')]);
			setLoading(false);
			return;
		}

		API.createAccount({
			first_name: form.data.first_name,
			last_name: form.data.last_name,
			email: form.data.email,
			password: form.data.password,
			captcha,
		}).then(res=>{
			if(res.error) return form.setPrompts([res.message]);
			setCreated(true);
		}).catch(err=>{
			form.setPrompts([t('common.unexpected_code', { code: 'LATH-ACCRT-1' })]);
		}).finally(()=>{
			setLoading(false);
		})
	}

	return <div className="ar login-screen create-screen">
		<div className="contents">
			<img className='ar logo' src={`${CDN_URL}/logo/LogoH_Large.webp`} alt="AREMA" />
			{created ? (
				<div className="complete">
					<Icon name='check-circle' color='green' />
					<div className="title">
						{t('create.created_title')}
					</div>
					<div className="subtitle">
						<Trans i18nKey={'create.created_subtitle'} values={{ email: form.data.email.toLowerCase() }} />
					</div>
					<Button color='black' text={t('common.login')} as={Link} to={`/${search}`} />
				</div>
			) : (
				<div className="form">
					<Input label={t('create.form.first_name')} value={form.data.first_name} onChange={form.onDataChange('first_name')} error={form.errors.first_name} />
					<Input label={t('create.form.last_name')} value={form.data.last_name} onChange={form.onDataChange('last_name')} error={form.errors.last_name} />
					<Input label={t('common.email')} value={form.data.email} onChange={form.onDataChange('email')} error={form.errors.email} />
					<div className="divider" style={{ margin: '20px 0 15px 0' }}>
						<div className="line dashed"></div>
					</div>
					<Input label={t('create.form.password')} value={form.data.password} onChange={form.onDataChange('password')} inputType='password' error={form.errors.password} />
					<Input label={t('create.form.repeat_password')} value={form.data.repeat_password} onChange={form.onDataChange('repeat_password')} inputType='password' error={form.errors.repeat_password} />

					<Message type='error' list={form.prompts} style={{ marginBottom: 10 }} />
					<div className="actions">
						<Button text={t('common.return')} basic as={Link} to={`/${search}`} />
						<Button text={t('create.send')} color='black' onClick={createAccount} />
					</div>
				</div>
			)}
		</div>
	</div>
}

export default AccountCreate;